import { Badge, Text, Tooltip } from '@radix-ui/themes'

interface TicketBadgeProps {
  count: number
}

export const TicketBadge = ({ count }: TicketBadgeProps) => {
  if (count <= 0) return null
  return (
    <Tooltip content={`${count} open support ticket${count === 1 ? '' : 's'}`}>
      <Badge color="orange" variant="soft" size="1">
        🎫 {count}
      </Badge>
    </Tooltip>
  )
}

// Table-cell variant: renders an em-dash placeholder when there are no open tickets.
export const TicketCell = ({ count }: TicketBadgeProps) =>
  count > 0 ? (
    <TicketBadge count={count} />
  ) : (
    <Text size="1" color="gray">
      —
    </Text>
  )
